import { Lang } from 'shared/constants';

const lang = Lang.METADATA_EXTRACTION;

export const METADATA_FIELDS = [
  { id: 'title', label: lang.FIELD_TITLE, description: lang.FIELD_TITLE_DESC },
  { id: 'subtitle', label: lang.FIELD_SUBTITLE, description: lang.FIELD_SUBTITLE_DESC },
  { id: 'keywords', label: lang.FIELD_KEYWORDS, description: lang.FIELD_KEYWORDS_DESC },
  {
    id: 'targetAudience',
    label: lang.FIELD_TARGET_AUDIENCE,
    description: lang.FIELD_TARGET_AUDIENCE_DESC,
  },
  { id: 'specialty', label: lang.FIELD_SPECIALTY, description: lang.FIELD_SPECIALTY_DESC },
  { id: 'subspecialty', label: lang.FIELD_SUBSPECIALTY, description: lang.FIELD_SUBSPECIALTY_DESC },
  { id: 'contentType', label: lang.FIELD_CONTENT_TYPE, description: lang.FIELD_CONTENT_TYPE_DESC },
];

/**
 * PolicyTech is the system of record for title and subtitle (they come from its export) and
 * fixes the content type (every PolicyTech document is a policy), so extraction must never
 * overwrite them — the next sync would revert it anyway. Keywords are not locked: the
 * backend merges extracted keywords on top of the synced list.
 */
export const SYNC_LOCKED_METADATA_FIELDS = new Set(['title', 'subtitle', 'contentType']);
